export const categories_types = [
  { id: 'text', name: 'text' },
  { id: 'link', name: 'link' },
  { id: 'default', name: 'default' },
];

export const site_languages = [
  { id: 'mk', name: 'MK' },
  { id: 'bg', name: 'BG' },
  { id: 'au', name: 'AU' },
  // { id: 'mk2', name: 'MK2' },
  { id: 'rs', name: 'RS' },
  { id: 'ca', name: 'CA' },
  { id: 'mt', name: 'MT' },
  { id: 'hr', name: 'HR' },
  { id: 'id', name: 'ID' },
  { id: 'ks', name: 'KS' },
  { id: 'ba', name: 'BA' },
  { id: 'me', name: 'ME' },
];

export const site_weights = [
  { id: 0.1, name: 0.1 },
  { id: 0.2, name: 0.2 },
  { id: 0.3, name: 0.3 },
  { id: 0.4, name: 0.4 },
  { id: 0.5, name: 0.5 },
  { id: 0.6, name: 0.6 },
  { id: 0.7, name: 0.7 },
  { id: 0.8, name: 0.8 },
  { id: 0.9, name: 0.9 },
  { id: 1, name: 1 },
];


// WEBPACK FOOTER //
// ./src/config/site_config.js